import React from 'react'
import {
  Home,
  Users,
  User,
  ShieldCheck,
  Folder,
  Image as ImageIcon,
  Tag,
  Hash,
  Settings as SettingsIcon,
  List,
  ShieldAlert,
  Circle,
  Shield,
  Lock,
  Key,
  Bell,
  Search,
  Plus,
  Edit,
  Trash2,
  Upload,
  Download,
  File,
  Files,
  FileText,
  Video,
  Archive,
  Layers,
  Boxes,
  Package,
  Box,
  Building2,
  ShoppingCart,
  Globe,
  Map,
  Calendar,
  Clock3,
  BarChart3,
  PieChart,
  Activity,
  Database,
  Server,
  Wrench,
  Hammer,
  Cog,
  Gauge,
  ClipboardList,
  ClipboardCheck,
  Newspaper,
  LineChart,
  CircleUser,
  TrendingUp,
  Sliders,
  Mail,
  Languages,
  Ticket,
  PanelLeftClose,
  PanelLeft,
  HelpCircle,
} from 'lucide-react'

const iconMap: Record<string, JSX.Element> = {
  home: <Home size={16} />,
  users: <Users size={16} />,
  user: <User size={16} />,
  'user-group': <Users size={16} />,
  'shield-check': <ShieldCheck size={16} />,
  shield: <Shield size={16} />,
  lock: <Lock size={16} />,
  key: <Key size={16} />,
  bell: <Bell size={16} />,
  search: <Search size={16} />,
  plus: <Plus size={16} />,
  edit: <Edit size={16} />,
  trash: <Trash2 size={16} />,
  folder: <Folder size={16} />,
  photo: <ImageIcon size={16} />,
  image: <ImageIcon size={16} />,
  video: <Video size={16} />,
  tag: <Tag size={16} />,
  hashtag: <Hash size={16} />,
  'cog-6-tooth': <SettingsIcon size={16} />,
  settings: <SettingsIcon size={16} />,
  cog: <Cog size={16} />,
  'list-bullet': <List size={16} />,
  list: <List size={16} />,
  'service type': <Boxes size={16} />,
  'service types': <Boxes size={16} />,
  'service-type': <Boxes size={16} />,
  'service-types': <Boxes size={16} />,
  'ticket status': <ClipboardCheck size={16} />,
  'ticket statuses': <ClipboardCheck size={16} />,
  'ticket-status': <ClipboardCheck size={16} />,
  'ticket-statuses': <ClipboardCheck size={16} />,
  'knowledge solution': <FileText size={16} />,
  'knowledge solutions': <FileText size={16} />,
  'knowledge-solution': <FileText size={16} />,
  'knowledge-solutions': <FileText size={16} />,
  'knowledge library': <FileText size={16} />,
  'knowledge-library': <FileText size={16} />,
  upload: <Upload size={16} />,
  download: <Download size={16} />,
  file: <File size={16} />,
  files: <Files size={16} />,
  document: <File size={16} />,
  'document-text': <FileText size={16} />,
  newspaper: <Newspaper size={16} />,
  archive: <Archive size={16} />,
  layers: <Layers size={16} />,
  boxes: <Boxes size={16} />,
  package: <Package size={16} />,
  box: <Box size={16} />,
  cube: <Box size={16} />,
  'check-circle': <ClipboardCheck size={16} />,
  'book-open': <FileText size={16} />,
  store: <Building2 size={16} />,
  'shopping-cart': <ShoppingCart size={16} />,
  globe: <Globe size={16} />,
  map: <Map size={16} />,
  calendar: <Calendar size={16} />,
  clock: <Clock3 size={16} />,
  'bar-chart': <BarChart3 size={16} />,
  'chart-bar': <BarChart3 size={16} />,
  'pie-chart': <PieChart size={16} />,
  'presentation-chart-line': <LineChart size={16} />,
  'user-circle': <CircleUser size={16} />,
  'document-chart-bar': <TrendingUp size={16} />,
  'clipboard-list': <ClipboardList size={16} />,
  'clipboard-document-list': <ClipboardList size={16} />,
  'adjustments-horizontal': <Sliders size={16} />,
  envelope: <Mail size={16} />,
  mail: <Mail size={16} />,
  activity: <Activity size={16} />,
  database: <Database size={16} />,
  server: <Server size={16} />,
  wrench: <Wrench size={16} />,
  tools: <Hammer size={16} />,
  gauge: <Gauge size={16} />,
  'shield-exclamation': <ShieldAlert size={16} />,
  language: <Languages size={16} />,
  languages: <Languages size={16} />,
  ticket: <Ticket size={16} />,
  'clipboard-document-check': <ClipboardCheck size={16} />,
  'panel-left-close': <PanelLeftClose size={16} />,
  'panel-left': <PanelLeft size={16} />,
  'help-circle': <HelpCircle size={16} />,
}

export function renderMenuIcon(name?: string): JSX.Element {
  const key = (name || '').toLowerCase()
  return iconMap[key] ?? <Circle size={10} />
}

